import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { withStores } from "stores";
import { withLocalization, LocalizedComponentProps } from "@shared-ui/localization-context";
import { PageHeadingProps } from "./typings";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";

@withLocalization
class PageHeading extends React.PureComponent<PageHeadingProps, LocalizedComponentProps> {
  public render() {
    const { pageHeading, pageSubHeadline } = this.props.compositionStore;

    if (!pageHeading) {
      return null;
    }

    const { showPageSubHeader, view } = this.props.flexComponent.model;
    const shouldShowSubHeadline = Boolean(
      pageSubHeadline && (typeof showPageSubHeader === "undefined" || showPageSubHeader)
    );

    const pageHeadingView = (
      <>
        <UitkText data-testid="dxPageHeading">{pageHeading}</UitkText>
        {shouldShowSubHeadline && (
          <UitkText size={400} weight="regular" spacing="one">
            {pageSubHeadline}
          </UitkText>
        )}
      </>
    );

    switch (view) {
      case "hidden":
        return <h1 className="sr-only">{pageHeading}</h1>;
      case "destination-discovery":
        return (
          <Viewport>
            <ViewSmall>
              <UitkSpacing padding="three">
                <UitkHeading level={1} size={800}>
                  <UitkLayoutFlex direction="column">{pageHeadingView}</UitkLayoutFlex>
                </UitkHeading>
              </UitkSpacing>
            </ViewSmall>

            <ViewLarge>
              <UitkLayoutFlex className="SimpleContainer">
                <UitkSpacing padding="three">
                  <UitkHeading level={1} size={900}>
                    <UitkLayoutFlex direction="column">{pageHeadingView}</UitkLayoutFlex>
                  </UitkHeading>
                </UitkSpacing>
              </UitkLayoutFlex>
            </ViewLarge>
          </Viewport>
        );
      case "affinity-launch":
        return (
          <UitkLayoutFlex
            direction="column"
            className="PageHeadingAffinityLaunch"
            data-testid="affinityLaunchPageHeading"
          >
            <UitkHeading level={1} size={800}>
              {pageHeading}
            </UitkHeading>

            {shouldShowSubHeadline && <UitkText spacing="one">{pageSubHeadline}</UitkText>}
          </UitkLayoutFlex>
        );
      default:
        return (
          <div
            className="PageHeading uitk-cell all-x-padding-three all-t-padding-six"
            data-fm={this.props.flexComponent.fmId}
            data-fm-title-id={this.props.flexComponent.fmTitleId}
          >
            <h1 className="uitk-type-heading-600">{pageHeading}</h1>
            {shouldShowSubHeadline && (
              <UitkText className="all-t-padding-one all-t-margin-two">{pageSubHeadline}</UitkText>
            )}
          </div>
        );
    }
  }
}

export default withStores("compositionStore")(PageHeading);
